// extracted by mini-css-extract-plugin
export default {"section":"HandClassificationTrainSection_section__xah6m","left":"HandClassificationTrainSection_left__ZauB4","right":"HandClassificationTrainSection_right__QakdE"};